import { RoutineCheckDurationsInMin } from 'src/constants/RoutineChecks';

export interface RoutineCheckElapsed {
    /** Minutes since the resident's last care activity. */
    current: number;
    /** Minutes allowed between routine checks. */
    max: number;
}

export interface RoutineCheckProgress {
    value: number;
    color: 'info' | 'warning' | 'error';
}

/* Turns time since the last care activity into a progress ring. */
export const getRoutineCheckProgress = (
    elapsed?: RoutineCheckElapsed
): RoutineCheckProgress | undefined => {
    if (!elapsed || elapsed.max <= 0) {
        return undefined;
    }

    const { current, max } = elapsed;
    const value = Math.min(Math.round((current / max) * 100), 100);
    const remaining = max - current;

    if (remaining <= 0) {
        return { value, color: 'error' };
    }

    if (remaining <= RoutineCheckDurationsInMin.WARNING_THRESHOLD) {
        return { value, color: 'warning' };
    }

    return { value, color: 'info' };
};
